export const transactionStatus = [{
  value: 'Undefined', label: 'Undefined', color: 'gray'
}, {
  value: 'Authorized', label: 'Authorized', color: 'green'
}, {
  value: 'Refund', label: 'Refund', color: 'yellow'
}, {
  value: 'Settled', label: 'Settled', color: 'blue'
}, {
  value: 'Failed', label: 'Failed', color: 'red'
}, {
  value: 'Planned', label: 'Planned', color: 'purple'
}];